import { useSyncExternalStore } from 'react'
import { msalInstance, loginRequest } from '../../lib/msalConfig'
import { sessionEstPerdue, surSessionPerdue, oublierSessionPerdue } from '../../lib/sessionPerdue'

/**
 * Issue #57 — la porte de sortie unique quand la session tombe.
 *
 * Montée une fois près de la racine (`AppShell`), elle remplace les bannières par page : un
 * événement, un message. Le bouton est **le seul** déclencheur de la reconnexion — c'est la leçon
 * de l'issue #43, où une redirection automatique avait produit une boucle sans écran ni sortie.
 *
 * Elle ne masque pas la page : l'utilisateur garde ce qui était déjà chargé sous les yeux, et peut
 * choisir son moment. Une session perdue n'est pas une erreur destructive, c'est une interruption.
 */
export function SessionPerdueBanner() {
  const perdue = useSyncExternalStore(surSessionPerdue, sessionEstPerdue, () => false)
  if (!perdue) return null

  const reconnecter = () => {
    // Oublier AVANT de partir : si la redirection échoue, la bannière ne doit pas rester figée sur
    // un état que plus rien ne remet à jour.
    oublierSessionPerdue()
    void msalInstance.loginRedirect(loginRequest)
  }

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 border-b border-border bg-highlight px-6 py-3"
    >
      <p className="font-body text-sm text-primary">
        Votre session a expiré. Reconnectez-vous pour continuer à consulter vos données.
      </p>
      <button
        type="button"
        onClick={reconnecter}
        className="rounded-md bg-primary px-4 py-1.5 font-body text-sm text-white transition-colors hover:bg-accent"
      >
        Se reconnecter
      </button>
    </div>
  )
}
